import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
 
export default function SuperAdminRoute({component, render, ...rest }) {
    const { currentUser } = useAuth()

  return (
    <Route
      {...rest}
      render={(props) => {

        return currentUser && currentUser.role==="superadmin" ? (component ? React.createElement(component, props) : render(props)) : <Redirect to="/" />
      }}
    />
  )
}
